/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  RiskIDRequestBody,
  RiskIDRequestBody$Outbound,
  RiskIDRequestBody$outboundSchema,
} from "../components/riskidrequestbody.js";

export type RevokeTemporaryGrantSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type RevokeTemporaryGrantRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  riskIDRequestBody: RiskIDRequestBody;
};

/** @internal */
export type RevokeTemporaryGrantSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const RevokeTemporaryGrantSecurity$outboundSchema: z.ZodMiniType<
  RevokeTemporaryGrantSecurity$Outbound,
  RevokeTemporaryGrantSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function revokeTemporaryGrantSecurityToJSON(
  revokeTemporaryGrantSecurity: RevokeTemporaryGrantSecurity,
): string {
  return JSON.stringify(
    RevokeTemporaryGrantSecurity$outboundSchema.parse(
      revokeTemporaryGrantSecurity,
    ),
  );
}

/** @internal */
export type RevokeTemporaryGrantRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  RiskIDRequestBody: RiskIDRequestBody$Outbound;
};

/** @internal */
export const RevokeTemporaryGrantRequest$outboundSchema: z.ZodMiniType<
  RevokeTemporaryGrantRequest$Outbound,
  RevokeTemporaryGrantRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    riskIDRequestBody: RiskIDRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      riskIDRequestBody: "RiskIDRequestBody",
    });
  }),
);

export function revokeTemporaryGrantRequestToJSON(
  revokeTemporaryGrantRequest: RevokeTemporaryGrantRequest,
): string {
  return JSON.stringify(
    RevokeTemporaryGrantRequest$outboundSchema.parse(
      revokeTemporaryGrantRequest,
    ),
  );
}
